import { API_URL } from '../utils/constants';

/**
 * API Service
 * Handles HTTP requests to the backend
 */
class ApiService {
  constructor() {
    this.baseURL = API_URL;
  }

  /**
   * Make a fetch request
   */
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Request failed');
      }

      return data;
    } catch (error) {
      console.error('API Request error:', error);
      throw error;
    }
  }

  /**
   * GET request
   */
  async get(endpoint, options = {}) {
    return this.request(endpoint, {
      method: 'GET',
      ...options
    });
  }

  /**
   * POST request
   */
  async post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
      ...options
    });
  }

  /**
   * PUT request
   */
  async put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
      ...options
    });
  }

  /**
   * DELETE request
   * @param {string} endpoint - API endpoint
   * @param {Object} params - Query parameters (will be appended to URL)
   * @param {Object} options - Additional fetch options
   */
  async delete(endpoint, params = null, options = {}) {
    // Convert params object to query string
    let url = endpoint;
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url = `${endpoint}?${queryString}`;
    }

    // DELETE requests typically don't have a body, so don't set Content-Type
    return this.request(url, {
      method: 'DELETE',
      headers: {},  // Override default Content-Type header
      ...options
    });
  }
}

export const api = new ApiService();
export default api;
